import { Paper, CircularProgress, Skeleton } from '@mui/material';

function WorkflowLoading() {
    return (
        <div>
            <Paper sx={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                height: {
                    xs: 'calc(100vh - 218px)',
                    sm: 'calc(100vh - 178px)',
                },
                minHeight: '300px'
            }}>
                <CircularProgress />
            </Paper>
            <Skeleton variant="rounded" height={40} width={160} sx={{ mt: 2 }} />
        </div>
    );

}

export default WorkflowLoading;